var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1 7.24317C7.43726 7.24317 6.9 7.78043 6.9 8.44317V25.2432C6.9 25.7577 7.22388 26.1967 7.67891 26.3672L20.4515 13.5946C20.9201 13.126 21.6799 13.126 22.1485 13.5946L26.1 17.5461V8.44317C26.1 7.78043 25.5627 7.24317 24.9 7.24317H8.1ZM28.5 20.442V8.44317C28.5 6.45495 26.8882 4.84317 24.9 4.84317H8.1C6.11177 4.84317 4.5 6.45495 4.5 8.44317V25.2432C4.5 27.2314 6.11178 28.8432 8.1 28.8432H24.9C26.8882 28.8432 28.5 27.2314 28.5 25.2432V20.4444C28.5 20.4436 28.5 20.4428 28.5 20.442ZM26.1 20.9402L21.3 16.1402L10.9971 26.4432H24.9C25.5627 26.4432 26.1 25.9059 26.1 25.2432V20.9402ZM12.3 12.0432C11.9686 12.0432 11.7 12.3118 11.7 12.6432C11.7 12.9745 11.9686 13.2432 12.3 13.2432C12.6314 13.2432 12.9 12.9745 12.9 12.6432C12.9 12.3118 12.6314 12.0432 12.3 12.0432ZM9.3 12.6432C9.3 10.9863 10.6431 9.64317 12.3 9.64317C13.9569 9.64317 15.3 10.9863 15.3 12.6432C15.3 14.3 13.9569 15.6432 12.3 15.6432C10.6431 15.6432 9.3 14.3 9.3 12.6432Z",
    fill: "#0C719C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.fb47e973f0411fb81e7dc66d98858dfe.svg";
export { ForwardRef as ReactComponent };